export const LOAD_CONTRACT = 'load'
export const SAVE_CONTRACT = 'save'
export const SAVE_DOCUMENT = 'saveDocument'
export const LOAD_DOCUMENT = 'loadDocument'

export const TRASH_CONTRACT = 'trash'
export const UNTRASH_CONTRACT = 'untrash'
export const DELETE_CONTRACT = 'delete'
